/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var isFunction = require('./isFunction')

var hasAlg = function (alg, m) { return isFunction(m[alg]) || isFunction(m['@@implements']) && !!m['@@implements'](alg); }

module.exports = hasAlg



//////////////////
// WEBPACK FOOTER
// ./~/crocks/core/hasAlg.js
// module id = ./node_modules/crocks/core/hasAlg.js
// module chunks = 0